import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col,Popover } from 'antd';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import help from '../../config/help.json';
import { QuestionCircleOutlined ,DownloadOutlined} from '@ant-design/icons';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;
var contentlist;

class Top10MovieTitle extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}



	render() {
		const { opensearchTop10MovieTitleList,opensearchMovieList } = this.props;
		cc_data = opensearchTop10MovieTitleList || [];
		cc_data = cc_data.sort((a, b) => b.doc_count - a.doc_count);
		contentlist = opensearchMovieList || [];
		
		function getPoster(contentid){
			let poster = require('../../../src/static/no_image.jpg');
			contentlist.forEach(c => {
				if(c._source && c._source.contentId && c._source.imageLandscape && c._source.contentId === contentid){
					poster =  c._source.imageLandscape;
				}				
			})
			return poster;
		};

		const settings = {
			focusOnSelect: true,
			infinite: false,
			variableWidth: true,
			slidesToScroll: 1,
			speed: 500,
		  };

		// let title, cast, director, genre, rating;
		// function getDetails(contentId){
		// 	let contentdetails = contentlist.find(f=>f._source.contentId === contentId);
		// 	if(contentdetails && contentdetails._source && contentdetails._source.imageLandscape){
		// 		poster = contentdetails._source.imageLandscape;
		// 	}
		// 	if(contentdetails && contentdetails._source && contentdetails._source.rating){
		// 		rating = contentdetails._source.rating;
		// 	}
		// 	if(contentdetails && contentdetails._source && contentdetails._source.metadata[0] && contentdetails._source.metadata[0].title){
		// 		title = contentdetails._source.metadata[0].title;
		// 	}
		// 	if(contentdetails && contentdetails._source && contentdetails._source.metadata[0] && contentdetails._source.metadata[0].genre){
		// 		genre = JSON.stringify(contentdetails._source.metadata[0].genre).replace(/"/g, '');
		// 	}
		// 	return <div>
		// 			<p>Title : {title}</p>
		// 			<p>Rating : {rating}</p>
		// 			<p>Genre : {genre}</p>
		// 			<img src = {poster} width={140}/>
		// 			</div>;
		// }

		
		//   let dataset = [];
		//   cc_data.map(d => {
		// 	dataset.push({key : d.key, doc_count: d.doc_count, contentId: d.contentId.buckets[0].key});
		// })
		// const columns = [
		// 	{
		// 	  title: 'Movie Title',
		// 	  dataIndex: 'key',
			  
		// 	},
		// 	{
		// 		title: 'Id',
		// 		dataIndex: 'contentId',
		// 		render: (text) => (
		// 			<>
		// 			  <Popover
		// 				placement="topLeft"
		// 				//title={text}
		// 				content={getDetails(text)}
		// 				trigger="click"
		// 			  >
		// 				<a>{text}</a>
		// 			  </Popover>
		// 			</>
		// 		  )
				
		// 	},
		// 	{
		// 	  title: 'Count',
		// 	  dataIndex: 'doc_count',
			  
		// 	}
		//   ];
		

		return (
      <Card className="analyticCard portraitPoster">
				<h3 className="title">{`Most Searched Movies  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='Top10MovieTitle').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map((c,k) => ({ items: k+1 , content_title: c.key ,content_id : c.contentId.buckets[0].key, count:c.doc_count}))} target="_blank" filename={"Most Searched Movies.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	{/* <Table style={{ height: 400, width: '100%' }} theme={userTheme} dataSource={dataset} columns={columns} pagination={{pageSize:5}} /> */}
					 <Slider   {...settings}>
							{
								cc_data.map((d, k) =>(
									<div key= 'poster' className='portaitPoster'>
										<div key='image' className='portaitPoster image'><img alt="" src={getPoster(d.contentId.buckets[0].key)}  style={{width:'100%' }}></img></div>
										<div key='title' className='portaitPoster detail'><p className="portaitPoster title">#{k+1}  {d.key}</p></div>
										<div key='views' className='portaitPoster detail'><p className="portaitPoster view">{d.doc_count} views</p></div>
									</div>
									)
									
								)
							}
						
						</Slider>
				</Col>
 				</Row>
     </Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchTop10MovieTitleList: state.search.opensearchTop10MovieTitleList,
	opensearchMovieList : state.analytics.opensearchMovieList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Top10MovieTitle));
